import { kpiColorCssVar, migrateLegacyKpiId } from "@nexus/kpi-formula"
import type { PerformanceKpiId } from "./my-brand-drawer-performance-catalog"
import { MY_BRAND_DRAWER_FATIGUE_CATALOG } from "./my-brand-drawer-fatigue-catalog"
import type { MyBrandKpiCatalogEntry } from "./my-brand-kpi-catalog"

/**
 * Resolve a fatigue-chart color from the org/user KPI catalog `colorToken`.
 * Falls back to a round-robin chart token so the line is never an undefined var.
 */
export function fatigueKpiColorVar(
  id: PerformanceKpiId,
  catalogById: Record<string, MyBrandKpiCatalogEntry>,
): string {
  const name = migrateLegacyKpiId(id)
  const fromCatalog = catalogById[name]?.colorVar
  if (fromCatalog) return fromCatalog
  const fallbackIndex = MY_BRAND_DRAWER_FATIGUE_CATALOG.findIndex((entry) => entry.id === id)
  return kpiColorCssVar(null, fallbackIndex < 0 ? 0 : fallbackIndex)
}
